module.exports = __webpack_public_path__ + "static/media/try-andie-arrow-up-pt.731aa14a.svg";